import { defineAsyncComponent } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import { GlDisclosureDropdown, GlDisclosureDropdownItem, GlToggle, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import isShowingLabelsQuery from '~/graphql_shared/client/is_showing_labels.query.graphql';
import setIsShowingLabelsMutation from '~/graphql_shared/client/set_is_showing_labels.mutation.graphql';
import LocalStorageSync from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/local_storage_sync.vue?vue3';
import Tracking from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import { historyPushState } from '~/lib/utils/common_utils';
import { mergeUrlParams, removeParams } from '~/lib/utils/url_utility';
import { GroupByParamType } from 'ee_else_ce/boards/constants';
const trackingMixin = Tracking.mixin();
export default {
    name: 'BoardOptions',
    components: {
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        GlToggle,
        LocalStorageSync,
        ToggleEpicsSwimlanes: defineAsyncComponent(()=>import('/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/boards/components/toggle_epics_swimlanes.vue?vue3'))
    },
    directives: {
        GlTooltipDirective
    },
    mixins: [
        trackingMixin
    ],
    props: {
        showEpicLaneOption: {
            type: Boolean,
            required: false,
            default: false
        },
        isSwimlanesOn: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'toggle-swimlanes'
    ],
    data () {
        return {
            isShowingLabels: null
        };
    },
    apollo: {
        isShowingLabels: {
            query: isShowingLabelsQuery,
            update: (data)=>data.isShowingLabels
        }
    },
    computed: {
        trackProperty () {
            return this.isShowingLabels ? 'on' : 'off';
        }
    },
    methods: {
        onToggleSwimLanes () {
            // Track toggle event
            this.track('click_toggle_swimlanes_button', {
                label: 'toggle_swimlanes',
                property: this.isSwimlanesOn ? 'off' : 'on'
            });
            // Track if the board has swimlane active
            if (!this.isSwimlanesOn) {
                this.track('click_toggle_swimlanes_button', {
                    label: 'swimlanes_active'
                });
            }
            this.toggleEpicSwimlanes();
        },
        toggleEpicSwimlanes () {
            if (this.isSwimlanesOn) {
                historyPushState(removeParams([
                    'group_by'
                ]), window.location.href, true);
                this.$emit('toggle-swimlanes', false);
            } else {
                historyPushState(mergeUrlParams({
                    group_by: GroupByParamType.epic
                }, window.location.href, {
                    spreadArrays: true
                }));
                this.$emit('toggle-swimlanes', true);
            }
        },
        setShowLabels () {
            this.$apollo.mutate({
                mutation: setIsShowingLabelsMutation,
                variables: {
                    isShowingLabels: !this.isShowingLabels
                }
            });
        }
    },
    i18n: {
        toggleText: __('View options'),
        showLabels: __('Show labels')
    }
};
